import i18next from 'i18next';
import { CHOOSE_DATE_PAGE_TRANSLATIONS } from '@/pages/supplies-management/_constants/translations';
import {
  RUB_FOR_LITER,
  LITERS_FOR_RUB,
  STANDART_PAID_ACCEPTANCE,
  NEXT_LITER,
} from '../_constants';

type TProps = {
  paidAcceptanceCoefficient: number;
  costForPalette: string;
  isPalette: boolean;
};

export const getDescription = ({
  paidAcceptanceCoefficient,
  costForPalette,
  isPalette,
}: TProps): string => {
  if (!paidAcceptanceCoefficient) {
    return i18next.t(CHOOSE_DATE_PAGE_TRANSLATIONS.hintFreeAcceptance);
  }
  if (isPalette) {
    return i18next.t(CHOOSE_DATE_PAGE_TRANSLATIONS.hintPaletteAcceptance, {
      cost: costForPalette,
    });
  }
  if (paidAcceptanceCoefficient === STANDART_PAID_ACCEPTANCE) {
    return i18next.t(CHOOSE_DATE_PAGE_TRANSLATIONS.hintPaidAcceptance, {
      coefficient: RUB_FOR_LITER,
      liters: LITERS_FOR_RUB,
      nextLiter: NEXT_LITER,
    });
  }

  return i18next.t(CHOOSE_DATE_PAGE_TRANSLATIONS.hintHighAcceptance, {
    coefficient: RUB_FOR_LITER,
    liters: LITERS_FOR_RUB,
    nextLiter: NEXT_LITER,
  });
};
